import _map from 'lodash/map'
import _size from 'lodash/size'

import Image from 'components/Image'
import Title from 'components/Title'
import Paragraph from 'components/Paragraph'
import Button from 'components/Button'
import Icon from 'components/Icon'
import Link from 'components/Link'

import asyncComponent from 'utils/asyncComponent'

import theme from 'style/theme'

import Styled from './styled'

const Carousel = asyncComponent(() => import('components/Carousel'))

export default function SectionSuccessStory({ data }) {
  const title = data?.title
  const contents = data?.contents
  const buttonText = data?.button?.title || 'ดูผลงานทั้งหมด'
  const link = data?.button?.url || '/blog/review?page=1'

  return (
    <Styled>
      <div className="content">
        <Paragraph className="title font-semibold">{title}</Paragraph>

        <div className="story-content">
          <Carousel
            options={{
              spaceBetween: 40,
              slidesPerView: 1,
              pagination: false,
              navigation: {
                nextEl: '.swiper-button-custom-next',
                prevEl: '.swiper-button-custom-prev',
              },
              breakpoints: {
                992: {
                  slidesPerView: 3,
                  pagination: false,
                },
              },
            }}
            items={contents}
            uiRenderer={(item, index) => {
              const name = item?.title
              const detail = item?.shortDescription
              const image = item?.coverImage?.url
              const altImage = item?.coverImage?.alternativeText
              const slug = item?.slug
              const categorySlug = 'review'
              const link = `/blog/${categorySlug}/${slug}`
              return (
                <Link href={link} openNewTab={true} key={index}>
                  <div className="story-item">
                    <div className="image-story">
                      <Image src={image} alt={altImage} />
                    </div>

                    <div className="info-block">
                      <Title level={4} ellipsis={{ rows: 1 }}>
                        {name}
                      </Title>
                      <Paragraph className="detail" ellipsis={{ rows: 3 }}>
                        {detail}
                      </Paragraph>

                      <Paragraph className="read-more">อ่านเพิ่มเติม &gt;&gt;</Paragraph>
                    </div>
                  </div>
                </Link>
              )
            }}
          />

          {_size(contents) > 3 && (
            <>
              <div className="swiper-button-custom swiper-button-custom-prev">
                <Icon.ChevronLeft style={{ fontSize: 40, color: theme.white }} />
              </div>
              <div className="swiper-button-custom swiper-button-custom-next">
                <Icon.ChevronRight style={{ fontSize: 40, color: theme.white }} />
              </div>
            </>
          )}
        </div>

        <div className="story-content-mobile">
          {_map(contents, (item, index) => {
            const name = item?.title
            const detail = item?.shortDescription
            const image = item?.coverImage?.url
            const slug = item?.slug
            const categorySlug = 'review'
            const link = `/blog/${categorySlug}/${slug}`

            return (
              <div className="story-item" key={index}>
                <div className="image-story">
                  <Image src={image} />
                </div>

                <div className="info-block">
                  <Title level={4} ellipsis={{ rows: 1 }}>
                    {name}
                  </Title>
                  <Paragraph className="detail" ellipsis={{ rows: 3 }}>
                    {detail}
                  </Paragraph>
                </div>
                <Link href={link} openNewTab={true}>
                  <div className="read-more-block">
                    <Paragraph className="read-more">อ่านเพิ่มเติม</Paragraph>
                  </div>
                </Link>
              </div>
            )
          })}
        </div>

        <div className="button-block">
          <Link href={link} openNewTab={true}>
            <Button dynamic type="ghost" size="large">
              {buttonText}
            </Button>
          </Link>
        </div>
      </div>
    </Styled>
  )
}
